import { NgClass, NgIf } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  DisplayValidationErrorsContainerDirective,
  DisplayValidationErrorsDirective,
  INoiseForm,
} from '@curbnturf/form-helpers';

@Component({
  selector: 'curbnturf-listing-noise',
  templateUrl: './listing-noise.component.html',
  styleUrls: ['./listing-noise.component.scss'],
  standalone: true,
  imports: [
    NgIf,
    NgClass,
    FormsModule,
    ReactiveFormsModule,
    DisplayValidationErrorsDirective,
    DisplayValidationErrorsContainerDirective,
  ],
})
export class ListingNoiseComponent {
  @Input() noiseForm: FormGroup<INoiseForm>;
  @Input() hideDescription: boolean = false;

  noiseErrorString: string | undefined;

  get level() {
    return this.noiseForm?.get('level') as FormControl<string | null>;
  }

  get description() {
    return this.noiseForm?.get('description') as FormControl<string | null>;
  }

  public validate() {
    if (!this.level.value) {
      this.noiseErrorString = 'Please select a level of noise.';
    } else {
      this.noiseErrorString = undefined;
    }
  }
}
